import React from 'react';
import { InLineAlert } from '@cxc/react-fpds-components';
import { ErrorDisplayProps } from '../../types/props/ErrorDisplayProps';

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ body, title, setErrorBanner }) => {
    const handleClose = () => {
        setErrorBanner(false);
    };

    return (
        <div style={{ marginTop: '48px' }}>
            <InLineAlert
                body={body}
                titleProp={{
                    title: title,
                    headingLevel: 'h1',
                }}
                variant="error"
                onClickClose={handleClose}
            />
        </div>
    );
};

export default ErrorDisplay;
